import { combineSlices } from "@reduxjs/toolkit";
import auth from "./modules/auth";
import global from "./modules/global";
import mainPages from "./modules/mainPages";

// ** Global
import globalCommon from "./modules/global-common.slice";
import globalViewTypes from "./modules/global-view-types.slice";
import sharedFilters from "./modules/shared-filters.slice";
import globalUser from "./modules/global-user/global-user.slice";

// ** Landing
import landing from "./modules/landing.slice";

// ** Main Pages
import mainPageHome from "./modules/main-pages/home/home.slice";
import mainPagePosts from "./modules/main-pages/posts/posts.slice";
import galleriesAll from "./modules/main-pages/galleries/galleries-all.slice";
import galleriesVideos from "./modules/main-pages/galleries/galleries-videos.slice";
import galleriesPhotos from "./modules/main-pages/galleries/galleries-photos.slice";
import mainPageSeoLocationsList from "./modules/main-pages/seo-locations-list/seo-locations-list.slice";
import mainPageSeoPreferencesList from "./modules/main-pages/seo-preferences-list/seo-preferences-list.slice";
import mainPageRankings from "./modules/main-pages/rankings/rankings.slice";
import mainPageUsers from "./modules/main-pages/users/users.slice";

// ** User Profile
import userProfileMain from "./modules/user-profile/user-profile-main.slice";
import userProfileMainContent from "./modules/user-profile/user-profile-main-content.slice";
import userProfileFriends from "./modules/user-profile/user-profile-friends.slice";
import userProfileGallery from "./modules/user-profile/user-profile-gallery.slice";

// ** Service Pages
import servicePageApp from "./modules/service-pages/app.slice";
import servicePageSupport from "./modules/service-pages/support.slice";
import servicePageTerms from "./modules/service-pages/terms.slice";
import servicePagePrivacy from "./modules/service-pages/privacy.slice";
import servicePageContact from "./modules/service-pages/contact.slice";
import servicePageNews from "./modules/service-pages/news.slice";

// ** Auth
import authLogin from "./modules/auth/auth-login.slice";

// ** Userpanel
import userpanelGalleryAndPosts from "./modules/userpanel/userpanel-gallery-and-posts.slice";

// ############################################################

const staticReducers = {
	auth,
	global,

	// ** Global
	globalCommon,
	globalViewTypes,
	sharedFilters,
	globalUser,

	// ** Landing
	landing,

	// ** Auth
	authLogin,

	// ** Main Pages
	mainPages,
	mainPageHome,
	mainPagePosts,
	galleriesAll,
	galleriesVideos,
	galleriesPhotos,
	mainPageSeoLocationsList,
	mainPageSeoPreferencesList,
	mainPageRankings,
	mainPageUsers,

	// ** User Profile
	userProfileMain,
	userProfileMainContent,
	userProfileFriends,
	userProfileGallery,

	// ** Service Pages
	servicePageApp,
	servicePageSupport,
	servicePageTerms,
	servicePagePrivacy,
	servicePageContact,
	servicePageNews,

	// ** Userpanel
	userpanelGalleryAndPosts,
};

export const injectReducers = (store, reducers) => {
	// Inicjalizacja asyncReducers jeśli nie istnieją
	if (!store.asyncReducers) store.asyncReducers = {};

	// Obsługa pojedynczego reducera (zachowanie kompatybilności wstecznej)
	if ("key" in reducers && "reducer" in reducers) {
		store.asyncReducers[reducers.key] = reducers.reducer;
	}
	// Obsługa wielu reducerów jako obiekt { [key]: reducer }
	else if (typeof reducers === "object") {
		store.asyncReducers = {
			...store.asyncReducers,
			...reducers,
		};
	}

	// Aktualizacja store z nowymi reducerami
	store.replaceReducer(
		combineSlices({
			...staticReducers,
			...store.asyncReducers,
		})
	);
};

// Zachowujemy starą funkcję dla kompatybilności wstecznej
export const injectReducer = (store, { key, reducer }) => {
	injectReducers(store, { key, reducer });
};

const createRootReducer = (asyncReducers = {}) =>
	combineSlices({
		...staticReducers,
		...asyncReducers,
	});

export default createRootReducer;
